module.exports = __webpack_public_path__ + "static/img/no-data.62c8008b.png";